/**
 * KRI alert status (RBQM) — single source of truth.
 */

import { createStatusHelpers } from "./statusHelpers";

export const KRI_STATUS = {
  OPEN: "Open",
  ACKNOWLEDGED: "Acknowledged",
  DISMISSED: "Dismissed",
  RESOLVED: "Resolved",
} as const;

export type KriStatusValue = (typeof KRI_STATUS)[keyof typeof KRI_STATUS];

const helpers = createStatusHelpers(KRI_STATUS, KRI_STATUS.OPEN);

export const KRI_STATUS_VALUES = helpers.VALUES;
export const tryNormalizeKriStatus = helpers.tryNormalize;
export const normalizeKriStatus = helpers.normalize;
export const isKriStatus = helpers.isStatus;
export const isAnyKriStatus = helpers.isAnyStatus;
